import { useEffect, useState } from 'react'
import { teamApi, type StaffMember } from '@/lib/api'

/**
 * Справочник сотрудников Центрики (team-access) для выпадающих списков «Менеджер» и
 * «Ответственный». Ошибка загрузки не показывается: список остаётся пустым, и поле выбора,
 * которое на него опирается, просто не предлагает вариантов.
 */
export function useStaff(enabled = true): StaffMember[] {
  const [staff, setStaff] = useState<StaffMember[]>([])
  useEffect(() => {
    if (!enabled) return
    const controller = new AbortController()
    teamApi
      .listStaff(controller.signal)
      .then((res) => {
        if (!controller.signal.aborted) setStaff(res.items)
      })
      .catch(() => undefined)
    return () => controller.abort()
  }, [enabled])
  return staff
}

/** Вариант выпадающего списка сотрудников. */
export interface StaffOption {
  id: string
  label: string
}

/**
 * Варианты выбора сотрудника: подпись — ФИО (у записи без ФИО — почта входа). `current` — уже
 * выбранный сотрудник: если его нет в справочнике действующих (учётная запись отключена),
 * он добавляется первым пунктом, иначе выбранное значение осталось бы без подписи.
 */
export function staffOptions(
  staff: Pick<StaffMember, 'id' | 'fullName' | 'email'>[],
  current?: { id: string; fullName: string },
): StaffOption[] {
  const options = staff.map((s) => ({ id: s.id, label: s.fullName || s.email }))
  if (current && !options.some((o) => o.id === current.id)) {
    options.unshift({ id: current.id, label: current.fullName || 'Сотрудник без ФИО' })
  }
  return options
}
